import {Injectable, NgZone} from "@angular/core";

export interface IdleTimeDetectorOptions {
    // The duration in seconds after which the user is considered idle.
    idleTime: number;
}

/**
 * Service that detects user inactivity and triggers a callback.
 */
@Injectable({
    providedIn: 'root'
})
export class IdleTimeDetector {

    constructor(
        private ngZone: NgZone
    ) {}

    /**
     * Detects if the user is idle and triggers the callback after the specified idle time.
     * @param options - Options that can be changed to detect user idle time (e.g., setting the idle time in seconds).
     * @param callback - The function to execute when the user is idle.
     */
    detectIdleTime(options: IdleTimeDetectorOptions, callback: () => void) {
        // Holds the current timeout's ID to allow resetting it.
        let timerId: number | null = null;
        const resetTimer = () => {
            if (timerId != null) {
                clearTimeout(timerId);
            }
            timerId = window.setTimeout(() =>{
                this.ngZone.run(() => callback());
            }, options.idleTime * 1000);
        };

        const events = ['mousemove', 'keydown', 'scroll', 'click'];
        this.ngZone.runOutsideAngular(() => {
            events.forEach(event => document.addEventListener(event, resetTimer));
            resetTimer();
        });
    }
}